import styled from 'styled-components';

export const Emoji = styled.img`
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    margin-bottom: 0px;
`;

export const CloseButton = styled.button`
    border: none;
    background: none;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: #434343;
    font-size: 18px;
    position: absolute;
    top: 12px; 
    right: 16px;
    cursor: pointer;
`

export const AlertTitle = styled.h2`
    color: var(--dark-laranja-dark, #EE3B5E);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    // line-height: 40px;
    margin-bottom: 10px;
`;

export const AlertMessage = styled.h2`
    color: var(--dark-laranja-dark, #EE3B5E);
    text-align: center;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    // line-height: 40px;
    margin-bottom: 10px;
`;

export const AlertBox = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
    border: 1px solid var(--dark-laranja-dark, #EE3B5E);
    background: var(--light-background, #FAC4CF);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    height: 160px;
    width: 436px;
`;